import { v4 as uuidv4 } from 'uuid';
import htmlToDraft from 'html-to-draftjs';
import { ContentState, EditorState, convertToRaw } from 'draft-js';

// convert html to draftjs-editorState and then return raw JS
// editorState is stored as raw JS object in the Redux store
const convertHtmlToRawJs = html => {
  const contentBlock = htmlToDraft(html);
  const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
  const editorState = EditorState.createWithContent(contentState);
  return convertToRaw(editorState.getCurrentContent());  
}

const html = "<div>Label</div>";
export default (item) => {

  const fieldPermission = {
    is_add_form:true,
    is_list:true,
    is_filters:true,
    is_detail_view:true,
    is_kanban_view:true,
    is_import:true,
    is_assign:true,
    related_window_name:'',
    has_related_window:false
  }
  switch (item) {
    case 'Header':
    case 'Paragraph':
    case 'Label':
      return {
        label: convertHtmlToRawJs(html)
      };

    case 'MultiCheckbox':
      return {
        label: convertHtmlToRawJs(html),
        required: false,
        helpText:"",
        isToolTip:false,
        default_value:"",
        quickCreate:false,
        isPlaceHolder:false,
        is_editable:true,
        is_removable:true,
        ...fieldPermission,
        options: [
          {
            id: "",//uuidv4(),
            value: 'Option1',
            checked: false
          },
          {
            id: "",//uuidv4(),
            value: 'Option2',
            checked: false
          }
        ]
      };
      case 'CheckBoxes':
        return {
          label: convertHtmlToRawJs(html),
          required: false,
          helpText:"",
          isToolTip:false,
          quickCreate:false,
          is_editable:true,
          is_removable:true,
          ...fieldPermission,
          default_value:"",
          // isPlaceHolder:false
        };
    case 'PickList':
      return {
        label: convertHtmlToRawJs(html),
        required: false,
        is_status_picklist:false,
        picklist_type:'NONE',
        converted_status:"",
        helpText:"",
        isToolTip:false,
        default_value:"",
        is_editable:true,
        is_removable:true,
        quickCreate:false,
        ...fieldPermission,
        // isPlaceHolder:false,
        isOrderByAsc:false,
        options: [
          {
            id: "",//uuidv4(),
            value: 'Option1',
            display_index:1,
          }
        ],
      };

    case 'HyperLink':
      return {
        label: convertHtmlToRawJs(html),
        required: false,
        quickCreate:false,
        helpText:"",
        is_editable:true,
        is_removable:true,
        isToolTip:false,
        isPlaceHolder:false,
        ...fieldPermission,
        value: ''
      };

    case 'LineBreak':
      return {};
    
    case 'Number':
      return {
        required: false,
        quickCreate:false,
        helpText:"",
        default_value:"",
        is_editable:true,
        is_removable:true,
        isToolTip:false,
        isPlaceHolder:false,
        ...fieldPermission,
        label: convertHtmlToRawJs(html),
        value: 0,
        max:9,
        // decimal:0,
        unique:false,
      };
    case 'AutoNumber':
        return {
          required: false,
          quickCreate:false,
          helpText:"",
          isToolTip:false,
          is_editable:true,
          is_removable:true,
          increment_by:1,
          // isPlaceHolder:false,
          label: convertHtmlToRawJs(html),
          value: 0,
          unique:false,
          ...fieldPermission,
        };  
      
    case 'RadioButtons':
      return {
        required: false,
        label: convertHtmlToRawJs(html),
        quickCreate:false,
        helpText:"",
        isToolTip:false,
        // isPlaceHolder:false,
        default_value:"",
        options: [
          {
            id: "",//uuidv4(),
            label: 'Label1',
            value: 'Value1',
            checked: false
          },
          {
            id: "",//uuidv4(),
            label: 'Label2',
            value: 'Value2',
            checked: false
          }
        ]
      };
    case 'MultiSelect':
      return {
        required: false,
        quickCreate:false,
        isToolTip:false,
        is_editable:true,
        is_removable:true,
        is_add_form:true,
        ...fieldPermission,
        // isPlaceHolder:false,
        default_value:"",
        label: convertHtmlToRawJs(html),
        options: [
          {
            id: "",//uuidv4(),
            label: 'Label1',
            value: 'Value1',
          },
          {
            id: "",//uuidv4(),
            label: 'Label2',
            value: 'Value2'
          }
        ],
      };

    case 'Range':
      return {
        required: false,
        quickCreate:false,
        helpText:"",
        isToolTip:false,
        isPlaceHolder:false,
        default_value:"",
        label: convertHtmlToRawJs(html),
        value: 0,
        min: 0,
        max: 5,
        step: 1
      };

    case 'Rating':
      return {
        required: false,
        quickCreate:false,
        helpText:"",
        isToolTip:false,
        isPlaceHolder:false,
        default_value:"",
        label: convertHtmlToRawJs(html),
        value: 0,
        numberOfStars: 5
      };

    case 'Email':
      return {
        required: false,
        quickCreate:false,
        helpText:"",
        isToolTip:false,
        is_editable:true,
        is_removable:true,
        isPlaceHolder:false,
        label: convertHtmlToRawJs(html),
        value: '',
        ...fieldPermission,
        unique:true,
      };
    case 'Phone':
        return {
          required: false,
          quickCreate:false,
          helpText:"",
          isToolTip:false,
          is_editable:true,
          is_removable:true,
          isPlaceHolder:false,
          default_value:"",
          label: convertHtmlToRawJs(html),
          value: '',
          charLimit:20,
          ...fieldPermission,
          unique:false,
        };  
    case 'TextInput':
        return {
          required: false,
          quickCreate:false,
          helpText:"",
          is_editable:true,
          is_removable:true,
          isToolTip:false,
          isPlaceHolder:false,
          default_value:"",
          label: convertHtmlToRawJs(html),
          value: '',
          is_default_displayname:false,
          charLimit:255,
          unique:false,
          ...fieldPermission,
        };
    case 'TextArea':
        return {
            required: false,
            quickCreate:false,
            helpText:"",
            isToolTip:false,
            is_editable:true,
            is_removable:true,
            isPlaceHolder:false,
            label: convertHtmlToRawJs(html),
            default_value:"",
            charLimit:2000,
            value: '',
            ...fieldPermission,
          };      
    case 'Date':
      return {
        required: false,
        quickCreate:false,
        is_editable:true,
        is_removable:true,
        label: convertHtmlToRawJs(html),
        value: '',
        default_value:'',
        helpText:"",
        isToolTip:false,
        isPlaceHolder:false,
        maxDate: null,
        minDate: null,
        ...fieldPermission,
      }
    case 'DateTime':
        return {
          required: false,
          quickCreate:false,
          label: convertHtmlToRawJs(html),
          value: '',
          default_value:'',
          is_editable:true,
          is_removable:true,
          helpText:"",
          isToolTip:false,
          isPlaceHolder:false,
          maxDate: null,
          minDate: null,
          ...fieldPermission,
      }
    case 'Time':
          return {
            required: false,
            quickCreate:false,
            label: convertHtmlToRawJs(html),
            value: '',
            default_value:"",
            is_editable:true,
            is_removable:true,
            helpText:"",
            isToolTip:false,
            isPlaceHolder:false,
            maxDate: null,
            minDate: null,
            ...fieldPermission,
      }      
      
    case 'Currency':
        return {
          required: false,
          quickCreate:false,
          max: 10,
          helpText:"",
          is_editable:true,
          is_removable:true,
          default_value:"",
          isToolTip:false,
          isPlaceHolder:false,
          currency_type:'SYMBOL',
          has_currency_conversion:false,
          label: convertHtmlToRawJs(html),
          value: 0,
          ...fieldPermission,
        }; 
    case 'Decimal':
        return {
            required: false,
            quickCreate:false,
            max: 10,
            is_editable:true,
            is_removable:true,
            helpText:"",
            default_value:"",
            isToolTip:false,
            isPlaceHolder:false,
            label: convertHtmlToRawJs(html),
            value: 0,
            ...fieldPermission,
          };     
    case 'LongNumber':
        return {
            required: false,
            quickCreate:false,
            max: 10,
            unique:false,
            helpText:"",
            is_editable:true,
            is_removable:true,
            default_value:"",
            isToolTip:false,
            isPlaceHolder:false,
            label: convertHtmlToRawJs(html),
            value: 0,
            ...fieldPermission,
          };      
    case 'Percentage':
      return {
            required: false,
            quickCreate:false,
            max: 5,
            helpText:"",
            is_editable:true,
            is_removable:true,
            default_value:"",
            isToolTip:false,
            isPlaceHolder:false,
            label: convertHtmlToRawJs(html),
            value: 0,
            ...fieldPermission,
          };       
    case 'FileUpload':
        return {
            required: false,
            quickCreate:false,
            helpText:"",
            is_editable:true,
            is_removable:true,
            isToolTip:false,
            isisPlaceHolder:false,
            label: convertHtmlToRawJs(html),
            value: "",
            max: 1,
            files:[],
            ...fieldPermission,
          }; 
    case 'ImageUpload':
          return {
                required: false,
                quickCreate:false,
                helpText:"",
                is_editable:true,
                is_removable:true,
                isToolTip:false,
                isisPlaceHolder:false,
                label: convertHtmlToRawJs(html),
                value: "",
                is_avatar:false,
                max: 10,
                files:[],
                ...fieldPermission,
            };           
    case 'Signature':
      return {
        required: false,
        quickCreate:false,
        helpText:"",
        isToolTip:false,
        isPlaceHolder:false,
        label: convertHtmlToRawJs(html),
        default_value:"",
        value: '',
        height: 300,
        width: 300,
        unique:false,
      };
      case 'Lookup':
        return {
          required: false,
          quickCreate:false,
          helpText:"",
          is_editable:true,
          is_removable:true,
          isToolTip:false,
          isPlaceHolder:false,
          // default_value:"",
          label: convertHtmlToRawJs(html),
          value: 0,
          relatedValue:"",
          lookup_window_data:null,
          ...fieldPermission,
          // unique:false,
        };   
      case 'MultiLookup':
          return {
            required: false,
            quickCreate:false,
            helpText:"",
            is_editable:true,
            is_removable:true,
            isToolTip:false,
            isPlaceHolder:false,
            // default_value:"",
            label: convertHtmlToRawJs(html),
            value: 0,
            relatedValue:"",
            lookup_window_data:null,
            ...fieldPermission,
            is_add_form:false,
            // unique:false,
          };
      case 'User':
        return {
          required: false,
          quickCreate:false,
          helpText:"",
          is_editable:true,
          is_removable:true,
          isToolTip:false,
          isPlaceHolder:false,
          is_single_user_reference:true,
          // default_value:"",
          label: convertHtmlToRawJs(html),
          value: 0,
          ...fieldPermission,
          // unique:false,
        };
      case 'Reminder':
        return {
          required: false,
          quickCreate:false,
          helpText:"",
          is_editable:true,
          is_removable:true,
          isToolTip:false,
          isPlaceHolder:false,
          is_single_user_reference:true,
          label: convertHtmlToRawJs(html),
          value: 0,
          ...fieldPermission,
        };            
      case 'Blank':
        return {    
          label: convertHtmlToRawJs('Blank_'+Math.floor(Math.random() * 100)),
          ...fieldPermission,
        }    
      case 'Barcode':
        return {
          quickCreate:false,
          helpText:"",
          required: false,
          isToolTip:false,
          is_editable:true,
          is_removable:true,
          increment_by:1,
          // isPlaceHolder:false,
          label: convertHtmlToRawJs(html),
          value: 0,
          unique:false,
          barcode_format: 'AZTEC',
          barcode_dimension: '0',
          barcode_encoding: 'UTF-8',
          barcodetext_type: '0',
          barcode_text: '',
          barcode_field: '',
          class_name:'',
          method_name:'execute',
          input:'',
          output:'',
          fieldVal:[],
          ...fieldPermission,
        };
      case 'PostalCode':
        return {
          required: false,
          quickCreate:false,
          helpText:"",
          is_editable:true,
          is_removable:true,
          isToolTip:false,
          isPlaceHolder:false,
          default_value:"",
          label: convertHtmlToRawJs(html),
          value: '',
          is_default_displayname:false,
          charLimit:255,
          unique:false,
          ...fieldPermission,
        };
      case 'Formula':
        return {
          quickCreate:false,
          helpText:"",
          required: false,
          isToolTip:false,
          is_editable:true,
          is_removable:true,
          increment_by:1,
          // isPlaceHolder:false,
          label: convertHtmlToRawJs(html),
          value: '',
          formula_returntype: '',
          is_formula_field: true,
          formula_expression: '',
          max:10,
          decimal:0,
          ...fieldPermission,is_add_form:true,
        };       
    default:
      return;
  }
}